<div class="full-width page-content page-padding" fxLayout="column">
  <div class="full-width" fxLayout="row" fxLayoutAlign="space-between center" fxFlexOffset="20px">
    <div class="full-width" fxLayout="row">
      <span class="subtitle-default full-width">{{header}}</span>
      <div fxLayoutGap="10px" fxFlexOffset="50px" *ngIf="createLease">
        <button (click)="openCreateLeaseTab()" class="button-action" mat-flat-button>
          <div class="button-text">Create a lease</div>
        </button>
      </div>
    </div>

    <div>
      @if (allowDownload) {
        <button mat-icon-button (click)="downloadApplication.emit()"
                matTooltip="Download contact details and application results"
                [disabled]="loading$ | async">
          <mat-icon class="material-icons-outlined" svgIcon="file_download"></mat-icon>
        </button>
      }
    </div>
  </div>

  <div class="full-width" fxLayout="row" fxLayoutGap="20px" fxFlexOffset="30px" *ngIf="retailer">
    <div class="info-card" fxLayout="column">
      <div class="fx-row fx-gap-20">
        <span class="heading-default">Company Information</span>
        <div class="fx-row fx-gap-10">
          <button (click)="editCompanyInformation(true)" *ngIf="!editingCompanyInformation"
                  [disabled]="!!(loading$ | async) || editingOwnerInformation"
                  class="button-action"
                  mat-flat-button>
            <div class="button-text">Update</div>
          </button>

          <button (click)="editCompanyInformation(false)" *ngIf="editingCompanyInformation"
                  [disabled]="(loading$ | async)"
                  class="button-action-cancel"
                  mat-flat-button>
            <div class="button-text">Cancel</div>
          </button>

          <button (click)="saveRetailerInformation()" *ngIf="editingCompanyInformation"
                  [disabled]="(loading$ | async)"
                  class="button-action"
                  mat-flat-button>
            <div class="button-text">Save</div>
          </button>
        </div>
      </div>

      <div [formGroup]="companyInformationForm" fxFlexOffset="20px" fxLayout="column" fxLayoutGap="15px">
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field (click)="openRetailerViewTab()" appearance="outline" class="custom-text-autofill"
                            floatLabel="always">
              <mat-label class="custom-form-field-link">System Id</mat-label>
              <input [value]="retailer.id!.toString()" disabled matInput type="text">
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
              <mat-label>Company Name</mat-label>
              <input matInput type="text" [value]="retailer.companyName" disabled>
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
              <mat-label>Industry Type</mat-label>
              <input matInput type="text" [value]="displayIndustriesList(retailer)" disabled>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
              <mat-label>Name</mat-label>
              <input matInput type="text" [value]="retailer.ownerFirstname" disabled>
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
              <mat-label>Surname</mat-label>
              <input matInput type="text" [value]="retailer.ownerLastname" disabled>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
              <mat-label>Website</mat-label>
              <input [disabled]="!!(loading$ | async)" formControlName="websiteUrl" matInput type="text"/>
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
              <mat-label>Social Link</mat-label>
              <input [disabled]="!!(loading$ | async)" formControlName="socialLink" matInput type="text"/>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field appearance="outline" class="custom-text-autofill" floatLabel="always">
              <mat-label>Company Phone Number</mat-label>
              <input [disabled]="!!(loading$ | async)" formControlName="phoneNumber" matInput type="text"/>
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field appearance="outline" class="custom-text-autofill" floatLabel="always">
              <mat-label>External Tenant Code</mat-label>
              <input [disabled]="!!(loading$ | async)" formControlName="externalTenantCode" matInput
                     type="text"/>
            </mat-form-field>
          </div>

        </div>
      </div>
    </div>

    <div class="info-card" fxLayout="column">
      <div class="fx-row fx-gap-20">
        <span class="heading-default">Owner Contact Information</span>
        <div class="fx-row fx-gap-10">
          <button (click)="editOwnerInformation(true)" *ngIf="!editingOwnerInformation" [disabled]="(loading$ | async) || editingCompanyInformation"
                  class="button-action"
                  mat-flat-button>
            <div class="button-text">Update</div>
          </button>

          <button (click)="editOwnerInformation(false)" *ngIf="editingOwnerInformation"
                  [disabled]="(loading$ | async)"
                  class="button-action-cancel"
                  mat-flat-button>
            <div class="button-text">Cancel</div>
          </button>

          <button (click)="updateOwnerInformation()" *ngIf="editingOwnerInformation"
                  [disabled]="(loading$ | async)"
                  class="button-action"
                  mat-flat-button>
            <div class="button-text">Save</div>
          </button>
        </div>
      </div>
      <div [formGroup]="userContactForm" fxFlexOffset="20px" fxLayout="column" fxLayoutGap="15px">
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field appearance="outline" class="custom-text-autofill" floatLabel="always">
              <mat-label>Email</mat-label>
              <input [value]="user ? user.email : null" disabled matInput type="text">
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field appearance="outline" class="custom-text-autofill" floatLabel="always">
              <mat-label>Owner Phone Number</mat-label>
              <input [disabled]="!editingOwnerInformation" formControlName="phoneNumber" matInput type="text">
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field appearance="outline" class="custom-select-field" floatLabel="always">
              <mat-label>Otp Preference</mat-label>
              <mat-select [disabled]="!editingOwnerInformation" formControlName="otpPreference">
                <mat-option *ngFor="let otp of otpOptions" [value]="otp.value">
                  {{ otp.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </div>

      </div>
    </div>
  </div>

</div>
